<div [id]="domId + slug"
     class="form-group"
     [gizmoDestinationInput]="formControl"
     [gizmoDestination]="this"
     *transloco="let t; read: 'blocks.' + block.type">

  <fieldset [id]="domId + slug + 'fieldset'">
    <legend *ngIf="!block.settings.hide_name"
            class="label name"
            [class.text-danger]="blocksConfig.editable && blocksConfig.localizable && !block.localizedName(currentContentLocale, originalContentLocale)">
      {{block.localizedName(currentContentLocale, originalContentLocale, true)}}

      <pl-required-indicator *ngIf="block.settings.required && blocksConfig.showRequiredIndicator && !ineligible" />
      <pl-readonly-indicator *ngIf="block.settings.readonly && blocksConfig.editable" />
    </legend>

    <ng-container [ngSwitch]="block.styles.format">
      <ng-container *ngSwitchCase="RadioInputFormat.LIST">
        <ng-container *ngFor="let option of options">
          <div class="custom-control custom-radio" *ngIf="option.settings.name.length > 0 || blocksConfig.editable"
               [class.custom-control-inline]="block.styles.inline">

            <input [id]="domId + slug + option.id"
                   [attr.name]="domId + slug"
                   type="radio"
                   class="custom-control-input"
                   [attr.aria-describedby]="domId + slug + option.id + 'label'"
                   [checked]="isChecked(option)"
                   (change)="select(option.id)"
                   [disabled]="ineligible || (block.settings.readonly && blocksConfig.submittable && !blocksConfig.editable)"
                   [readonly]="(block.settings.readonly && !blocksConfig.editable) || (!blocksConfig.editable && !blocksConfig.submittable)">
            <label [id]="domId + slug + option.id + 'label'" [for]="domId + slug + option.id" class="custom-control-label"
                   [class.text-muted]="option.settings.name.length === 0">
              <span [class.text-danger]="blocksConfig.editable && blocksConfig.localizable
                                          && !option.localizedName(currentContentLocale, originalContentLocale)
                                          && !(option.settings.name.length === 0)">
                {{ option.localizedName(currentContentLocale, originalContentLocale, true) || ('blocks.' + block.type + '.new_option' | transloco) }}
              </span>
            </label>

          </div>
        </ng-container>
      </ng-container>

      <div *ngSwitchCase="RadioInputFormat.BUTTONS" class="buttons" [class.full-width]="block.settings.fullWidth">
        <pl-option-buttons
          [options]="options"
          [currentContentLocale]="currentContentLocale"
          [originalContentLocale]="originalContentLocale"
          [data]="[data]"
          [disabled]="ineligible || (block.settings.readonly && blocksConfig.submittable && !blocksConfig.editable)"
          [readonly]="(block.settings.readonly && !blocksConfig.editable) || (!blocksConfig.editable && !blocksConfig.submittable)"
          [name]="domId"
          (check)="select($event.id)"
          [class.full-width]="block.settings.fullWidth" />
      </div>

      <ng-container *ngSwitchCase="RadioInputFormat.DROPDOWN">
        <div class="select-wrapper">
          <select *ngIf="blocksConfig.editable || blocksConfig.submittable"
                  class="custom-select form-control"
                  [value]="data"
                  #selectElement
                  [class.is-invalid]="(!blocksConfig.editable || blocksConfig.preview) && blocksConfig.validation && formControl.touched && !isValid()"
                  [class.is-valid]="(!blocksConfig.editable || blocksConfig.preview) && blocksConfig.validation && formControl.dirty && isValid()"
                  [class.text-danger]="(!blocksConfig.editable || blocksConfig.preview) && blocksConfig.validation && formControl.touched && !isValid()"
                  (change)="select(+selectElement.value)"
                  [disabled]="ineligible || (block.settings.readonly && blocksConfig.submittable && !blocksConfig.editable)"
                  [class.readonly]="ineligible || (block.settings.readonly && !blocksConfig.editable) || (!blocksConfig.editable && !blocksConfig.submittable) || (isOverlay && blocksConfig.editable && !blockComponent?.selected)"
                  [class.empty]="!selectElement.value"
                  [fontSize]="block.settings.fontSize"
                  [fontSizeEnabled]="isOverlay || block.settings.fontSize !== 16"
                  [style.padding-top.px]="isOverlay ? block.settings.paddingY : undefined"
                  [style.padding-bottom.px]="isOverlay ? block.settings.paddingY : undefined"
                  [style.padding-left.px]="isOverlay ? block.settings.paddingX : undefined"
                  [style.padding-right.px]="isOverlay ? block.settings.paddingX : undefined">
            <option disabled [ngValue]="" [selected]="!this.data">
              {{t('choose_option')}}
            </option>
            <option [value]="option.id" *ngFor="let option of options" [selected]="isChecked(option)">
              {{ option.localizedName(currentContentLocale, originalContentLocale, true) || t('new_option') }}
            </option>
          </select>

          <fa-icon [class.disabled]="ineligible" size="sm" icon="chevron-down"></fa-icon>

          <p *ngIf="!blocksConfig.editable && !blocksConfig.submittable"
             class="mb-0"
             [id]="domId + slug"
             [class.form-control]="!isOverlay"
             [class.form-control-overlay]="isOverlay"
             [fontSize]="block.settings.fontSize"
             [fontSizeEnabled]="isOverlay || block.settings.fontSize !== 16"
             [style.padding-top.px]="isOverlay ? block.settings.paddingY : undefined"
             [style.padding-bottom.px]="isOverlay ? block.settings.paddingY : undefined"
             [style.padding-left.px]="isOverlay ? block.settings.paddingX : undefined"
             [style.padding-right.px]="isOverlay ? block.settings.paddingX : undefined">

            <b *ngIf="block.settings.hide_name && data && !isOverlay">
              {{block.localizedName(currentContentLocale, originalContentLocale, true)}}:
            </b>
            <ng-container *ngFor="let option of options">
              <ng-container *ngIf="isChecked(option)">
                {{ option.localizedName(currentContentLocale, originalContentLocale, true) }}
              </ng-container>
            </ng-container>

            <span *ngIf="!data && !blocksConfig.printOptimized" class="placeholder">{{t('choose_option')}}</span>
          </p>
        </div>
      </ng-container>
    </ng-container>

    <div *ngIf="(!blocksConfig.editable || blocksConfig.preview) && blocksConfig.validation && formControl.touched && !isValid()"
         class="d-block text-danger">
      {{t('errors.required')}}
    </div>

    <small *ngIf="block.localizedHelpText(currentContentLocale, originalContentLocale,true)"
           [id]="domId + slug + 'helptext'"
           [class.text-danger]="blocksConfig.editable && blocksConfig.localizable && !block.localizedHelpText(currentContentLocale, originalContentLocale)"
           class="form-text text-muted" aria-hidden="true">
      {{block.localizedHelpText(currentContentLocale, originalContentLocale, true)}}
    </small>
  </fieldset>
</div>

<pl-ineligibility-overlay *ngIf="ineligible" mode="select" />
